import styled from 'styled-components';
import { newColors, theme } from '~/themes/variables';
export const Container = styled.div `
  background-color: ${newColors.transparent50};
  position: fixed;
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
`;
export const Form = styled.form `
  background-color: ${newColors.snow};
  border-radius: 12px;
  box-sizing: border-box;
  padding: 28px 28px 16px;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 343px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Inter Variable', sans-serif;
  gap: 24px;
`;
export const Header = styled.div ``;
export const CloseButton = styled.button `
  border: 0;
  background: none;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;
export const Body = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
export const Title = styled.div `
  color: ${theme.colors.brandPrimary};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;
export const Question = styled.div `
  color: ${theme.colors.textPrimary};
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
`;
export const RatingContainer = styled.div `
  display: flex;
  gap: 8px;
  margin: 16px 0 0;
`;
export const RatingBoxContainer = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 50px;
  gap: 8px;
`;
export const RatingBox = styled.div `
  width: 39px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border-style: solid;
  border-width: ${({ selected }) => (selected ? '2px' : '1px')};
  border-color: ${({ selected }) => (selected ? theme.colors.brandPrimary : theme.colors.borderPrimary)};
  background-color: ${newColors.gray50};
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    border-color: ${theme.colors.brandPrimary};
    border-width: 2px;
  }
`;
export const RatingLabel = styled.span `
  font-size: 12px;
  color: ${theme.colors.label};
`;
export const HiddenContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: ${({ isVisible }) => (isVisible ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;
export const HR = styled.hr `
  background-color: ${theme.colors.borderSecondary};
  border: 0;
  height: 1px;
  margin: 0;
  width: 100%;
`;
export const SubTitle = styled.div `
  color: ${theme.colors.textSecondary700};
  font-size: 14px;
  line-height: 20px;
`;
export const SideText = styled.span `
  color: ${theme.colors.textSecondary700};
  font-size: 12px;
`;
export const Textarea = styled.textarea `
  border: 1px solid ${theme.colors.borderPrimary};
  border-radius: 8px;
  padding: 13px 14px;
  width: -webkit-fill-available;
  height: 100px;
`;
export const Button = styled.button `
  background-color: ${theme.colors.brandPrimary};
  border: 1px solid ${theme.colors.brandPrimary};
  border-radius: 8px;
  padding: 10px 14px;
  text-align: center;
  color: ${newColors.snow};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  margin-bottom: 16px;

  &:hover {
    background-color: transparent;
    color: ${theme.colors.brandPrimary};
  }
`;
